<template></template>

<script>
import swal from 'sweetalert'

export default {
  props: {
    type: {
      type: String
    },
    title: {
      type: String
    },
    message: {
      type: String
    }
  },
  computed: {
    notificationType() {
      switch (this.type) {
        case 'success': 
          return 'notifier--success'
        case 'error':
          return 'notifier--error'
      }
    }
  },
  methods: {
    clearNotification() {
      this.$store.dispatch('clearNotification')
    }
  },
  watch: {
    message() {
      if (this.message.length > 0) {
        
        let title = ''
        if (this.title.length > 0) {
          title = '<span class="alerts alerts--no-brdr ' + this.type + '">' + this.title + '</span>'
        }

        let swalContent = document.createElement('div')
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr ' + this.type + '">' + this.message + '</p>'

        swal({
          title: title,
          content: swalContent,
        })
      }
    }
  }
}
</script>
